import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import token from '../assets/dollar.png'
export const googleAuthService = {
  login: async () => {
    console.log('🔄 Начало процесса входа через Google');
    
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      
      // Добавляем подробное логирование
      console.log('📝 Настройка Google провайдера');
      
      // Добавляем необходимые области доступа
      provider.addScope('email');
      provider.addScope('profile');
      
      console.log('🔑 Вызов signInWithPopup для Google аутентификации');
      
      // Используем signInWithRedirect вместо signInWithPopup для обхода проблем с COOP
      // Но сначала пробуем popUp с настройками
      
      // Устанавливаем настройки для обхода проблем с COOP
      auth.settings.appVerificationDisabledForTesting = true;
      
      // Пробуем использовать попап, но с опцией обработки ошибок COOP
      
      // Создаем модальное окно с кнопкой
      const modal = document.createElement('div');
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100%';
      modal.style.height = '100%';
      modal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
      modal.style.zIndex = '9999';
      modal.style.display = 'flex';
      modal.style.justifyContent = 'center';
      modal.style.alignItems = 'center';
      
      const modalContent = document.createElement('div');
      modalContent.style.backgroundColor = 'white';
      modalContent.style.borderRadius = '10px';
      modalContent.style.padding = '30px';
      modalContent.style.maxWidth = '400px';
      modalContent.style.width = '90%';
      modalContent.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
      
      const modalTitle = document.createElement('h3');
      modalTitle.textContent = 'Выполняется вход через Google...';
      modalTitle.style.marginBottom = '20px';
      modalTitle.style.textAlign = 'center';
      
      const statusText = document.createElement('p');
      statusText.textContent = 'Пожалуйста, подождите. Выполняется вход...';
      statusText.style.textAlign = 'center';
      
      // Добавляем анимацию загрузки
      const spinner = document.createElement('div');
      spinner.style.border = '4px solid #f3f3f3';
      spinner.style.borderTop = '4px solid #3498db';
      spinner.style.borderRadius = '50%';
      spinner.style.width = '30px';
      spinner.style.height = '30px';
      spinner.style.animation = 'spin 2s linear infinite';
      spinner.style.margin = '20px auto';
      
      // Добавляем стиль анимации
      const style = document.createElement('style');
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
      
      modalContent.appendChild(modalTitle);
      modalContent.appendChild(spinner);
      modalContent.appendChild(statusText);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);
      
      console.log('🔄 Пытаемся войти через Google API напрямую');
      
      try {
        // Прямой вызов Google API для аутентификации
        let result = await signInWithPopup(auth, provider);
        console.log('✅ Успешный вход через Google API!');
        
        // Удаляем модальное окно после успешной аутентификации
        if (document.body.contains(modal)) {
          document.body.removeChild(modal);
        }
        
        // Обрабатываем пользователя
        console.log('🔄 Обработка данных пользователя');
        const userData = await processUserData(result.user);
        console.log('✅ Данные пользователя обработаны:', userData);
        
        // Создаем модальное окно успешного входа
        console.log('🎉 Создаем модальное окно успешного входа');
        createSuccessModal(userData);
        
        // Уведомляем об успешной аутентификации
        console.log('📢 Отправка события успешной аутентификации');
        window.dispatchEvent(new CustomEvent('googleAuthComplete', {
          detail: { success: true, user: userData }
        }));
        
        return { success: true, user: userData };
      } catch (directError) {
        console.error('❌ Error during Google API call:', directError);
        
        // Обновляем текст в модальном окне
        statusText.textContent = 'Authentication failed. Please try again later.';
        statusText.style.color = 'red';
        
        // Добавляем кнопку закрытия
        const closeButton = document.createElement('button');
        closeButton.textContent = 'Close';
        closeButton.style.marginTop = '20px';
        closeButton.style.padding = '10px 20px';
        closeButton.style.border = 'none';
        closeButton.style.borderRadius = '5px';
        closeButton.style.backgroundColor = '#3498db';
        closeButton.style.color = 'white';
        closeButton.style.cursor = 'pointer';
        closeButton.onclick = () => {
          if (document.body.contains(modal)) {
            document.body.removeChild(modal);
          }
        };
        
        modalContent.appendChild(closeButton);
        
        // Создаем фиктивные данные пользователя для показа модального окна
        const dummyUserData = {
          isNewUser: true,
          uid: 'dummy-user-id',
          email: '',
          displayName: 'Guest User',
          tokens: 126
        };
        
        // Показываем модальное окно даже при ошибке
        console.log('🎉 Создаем модальное окно успешного входа (даже при ошибке)');
        createSuccessModal(dummyUserData);
        
        throw directError;
      }
    } catch (error) {
      console.error('❌ Ошибка аутентификации с Google:', error);
      
      let errorMessage = 'Произошла ошибка при входе через Google';
      
      // Отправляем событие об ошибке аутентификации
      console.log('📢 Отправка события об ошибке аутентификации');
      window.dispatchEvent(new CustomEvent('googleAuthComplete', { 
        detail: { success: false, error: errorMessage } 
      }));
      
      return { error: errorMessage, success: false };
    }
  }
};

// Функция для получения изображения из DOM
const getImageSrcFromDOM = (selector, fallbackSrc) => {
  try {
    const imgElement = document.querySelector(selector);
    if (imgElement && imgElement.src) {
      console.log(`✅ Найдено изображение для ${selector}:`, imgElement.src);
      return imgElement.src;
    }
    console.warn(`⚠️ Изображение для ${selector} не найдено, используем запасной вариант`);
    return fallbackSrc;
  } catch (error) {
    console.error(`❌ Ошибка при получении изображения для ${selector}:`, error);
    return fallbackSrc;
  }
};

// Функция для создания модального окна успешного входа
const createSuccessModal = (userData) => {
  console.log('🎨 Создание модального окна успешного входа по дизайну Apple');
  
  // Определяем, новый ли пользователь
  const isNewUser = userData.isNewUser;
  
  // Создаем контейнер модального окна
  const modal = document.createElement('div');
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.width = '100%';
  modal.style.height = '100%';
  modal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
  modal.style.zIndex = '9999';
  modal.style.display = 'flex';
  modal.style.justifyContent = 'center';
  modal.style.alignItems = 'center';
  
  // Функция закрытия модального окна
  const closeSuccessModal = () => {
    console.log('🔄 Закрытие модального окна успешного входа');
    if (document.body.contains(modal)) {
      document.body.removeChild(modal);
    }
  };

  // Закрытие по клику вне окна
  modal.onclick = (event) => {
    if (event.target === modal) {
      closeSuccessModal();
    }
  };

  // Закрытие по нажатию Escape
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeSuccessModal();
      // Удаляем обработчик после закрытия
      document.removeEventListener('keydown', handleKeyDown);
    }
  };
  document.addEventListener('keydown', handleKeyDown);
  
  // Создаем содержимое модального окна
  const modalContent = document.createElement('div');
  modalContent.style.backgroundColor = 'white';
  modalContent.style.borderRadius = '20px';
  modalContent.style.padding = '30px';
  modalContent.style.maxWidth = '400px';
  modalContent.style.width = '90%';
  modalContent.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
  modalContent.style.textAlign = 'center';
  modalContent.style.position = 'relative';
  
  // Добавляем кнопку закрытия
  const closeButton = document.createElement('button');
  closeButton.innerHTML = '&times;';
  closeButton.style.position = 'absolute';
  closeButton.style.top = '15px';
  closeButton.style.right = '15px';
  closeButton.style.backgroundColor = 'transparent';
  closeButton.style.border = 'none';
  closeButton.style.fontSize = '30px';
  closeButton.style.lineHeight = '1';
  closeButton.style.color = '#aaa';
  closeButton.style.cursor = 'pointer';
  closeButton.style.padding = '0';
  closeButton.style.width = '30px';
  closeButton.style.height = '30px';
  closeButton.style.display = 'flex';
  closeButton.style.alignItems = 'center';
  closeButton.style.justifyContent = 'center';
  closeButton.onclick = closeSuccessModal;
  
  // Добавляем заголовок
  const modalTitle = document.createElement('h2');
  modalTitle.textContent = isNewUser ? 'Exclusive Offer' : 'Special Offer';
  modalTitle.style.color = '#f9c846'; // Желтый цвет как в Apple Auth
  modalTitle.style.fontSize = '32px';
  modalTitle.style.fontWeight = 'bold';
  modalTitle.style.marginBottom = '25px';
  modalTitle.style.marginTop = '0px';
  modalTitle.style.fontFamily = '-apple-system, Black han sans';
  
  // Создаем список преимуществ
  const benefitsList = document.createElement('div');
  benefitsList.style.marginBottom = '30px';
  benefitsList.style.textAlign = 'left';
  
  // Функция для создания элемента преимущества
  const createBenefitItem = (icon, title, description, highlight = null) => {
    const benefitItem = document.createElement('div');
    benefitItem.style.display = 'flex';
    benefitItem.style.alignItems = 'flex-start';
    benefitItem.style.marginBottom = '20px';
    
    // Иконка преимущества
    const benefitIcon = document.createElement('div');
    benefitIcon.style.width = '40px';
    benefitIcon.style.height = '40px';
    benefitIcon.style.borderRadius = '10px';
    benefitIcon.style.display = 'flex';
    benefitIcon.style.alignItems = 'center';
    benefitIcon.style.justifyContent = 'center';
    benefitIcon.style.marginRight = '15px';
    benefitIcon.style.flexShrink = '0';
    
    // Если иконка - изображение
    if (typeof icon === 'string' && icon.includes('/')) {
      const iconImg = document.createElement('img');
      iconImg.src = icon;
      iconImg.style.width = '24px';
      iconImg.style.height = '24px';
      benefitIcon.appendChild(iconImg);
    } else {
      // Если иконка - эмоджи или текст
      benefitIcon.innerHTML = `<span style="font-size: 24px;">${icon}</span>`;
    }
    
    // Текстовый блок преимущества
    const benefitText = document.createElement('div');
    benefitText.style.flex = '1';
    
    // Заголовок преимущества
    const benefitTitle = document.createElement('div');
    benefitTitle.style.fontWeight = '600';
    benefitTitle.style.fontSize = '17px';
    benefitTitle.style.color = '#333';
    benefitTitle.style.marginBottom = '4px';
    
    // Если есть выделенный текст, форматируем заголовок с выделением
    if (highlight) {
      const titleParts = title.split(highlight);
      benefitTitle.innerHTML = titleParts[0];
      
      const highlightSpan = document.createElement('span');
      highlightSpan.textContent = highlight;
      highlightSpan.style.color = '#f9c846';
      highlightSpan.style.fontWeight = '700';
      highlightSpan.style.fontSize = '20px';
      
      benefitTitle.appendChild(highlightSpan);
      
      if (titleParts[1]) {
        benefitTitle.innerHTML += titleParts[1];
      }
    } else {
      benefitTitle.textContent = title;
    }
    
    // Описание преимущества
    const benefitDescription = document.createElement('div');
    benefitDescription.textContent = description;
    benefitDescription.style.fontSize = '14px';
    benefitDescription.style.color = '#666';
    benefitDescription.style.lineHeight = '1.4';
    
    benefitText.appendChild(benefitTitle);
    benefitText.appendChild(benefitDescription);
    
    benefitItem.appendChild(benefitIcon);
    benefitItem.appendChild(benefitText);
    
    return benefitItem;
  };
  
  // Добавляем элементы преимуществ как в Apple Auth
  const tokenCount = isNewUser ? '126' : '96';
  benefitsList.appendChild(createBenefitItem(
    token, 
    `Get ${tokenCount} tokens`, 
    'to create amazing recipes from your leftovers',
    tokenCount
  ));
  
  benefitsList.appendChild(createBenefitItem(
    '🍽️', 
    'Make 3 meals at once', 
    'instead of just one recipe idea',
    '3'
  ));
  
  benefitsList.appendChild(createBenefitItem(
    '✨', 
    'Personalized cooking', 
    'tailored to your preferences and dietary needs'
  ));
  
  // Создаем кнопку App Store
  const appStoreButtonContainer = document.createElement('div');
  appStoreButtonContainer.style.borderRadius = '10px';
  appStoreButtonContainer.style.padding = '10px 0';
  appStoreButtonContainer.style.margin = '0 auto 25px';
  appStoreButtonContainer.style.width = '100%';
  appStoreButtonContainer.style.maxWidth = '350px';
  appStoreButtonContainer.style.cursor = 'pointer';
  
  const appStoreLink = document.createElement('a');
  appStoreLink.href = 'https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693';
  appStoreLink.target = '_blank';
  appStoreLink.style.textDecoration = 'none';
  appStoreLink.style.display = 'block';
  
  // Используем изображение кнопки App Store
  const appStoreImg = document.createElement('img');
  appStoreImg.src = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';
  appStoreImg.alt = 'Download on the App Store';
  appStoreImg.style.height = '56px';
  appStoreImg.style.margin = '0 auto';
  appStoreImg.style.display = 'block';
  
  appStoreLink.appendChild(appStoreImg);
  appStoreButtonContainer.appendChild(appStoreLink);
  
  appStoreButtonContainer.onclick = () => {
    console.log('🔄 Переход в App Store');
    window.open('https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693', '_blank');
    
    // Закрываем модальное окно
    setTimeout(() => {
      if (document.body.contains(modal)) {
        document.body.removeChild(modal);
      }
    }, 300);
  };
  
  // Создаем кнопку "Maybe later"
  const laterButton = document.createElement('button');
  laterButton.textContent = 'Maybe later';
  laterButton.style.backgroundColor = '#fff';
  laterButton.style.color = '#666';
  laterButton.style.border = 'none';
  laterButton.style.padding = '12px 30px';
  laterButton.style.borderRadius = '50px'; // Скругленная кнопка
  laterButton.style.fontSize = '14px';
  laterButton.style.cursor = 'pointer';
  laterButton.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; // Легкая тень
  laterButton.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
  laterButton.onclick = closeSuccessModal;
  
  // Собираем модальное окно
  modalContent.appendChild(closeButton);
  modalContent.appendChild(modalTitle);
  modalContent.appendChild(benefitsList); // Добавляем список преимуществ вместо простого текста
  modalContent.appendChild(appStoreButtonContainer);
  modalContent.appendChild(laterButton);
  modal.appendChild(modalContent);
  
  // Добавляем на страницу
  document.body.appendChild(modal);
  
  console.log('✅ Модальное окно специального предложения создано в стиле Apple Auth');
};

// Обработка данных пользователя в Firestore
const processUserData = async (firebaseUser) => {
  console.log('🔄 Обработка данных пользователя в Firestore:', firebaseUser.uid);
  
  try {
    // Проверяем существует ли пользователь в Firestore
    const userDocRef = doc(db, 'users', firebaseUser.uid);
    const userSnapshot = await getDoc(userDocRef);

    console.log('🔍 Проверка существования пользователя в БД:', userSnapshot.exists());

    if (!userSnapshot.exists()) {
      console.log('🆕 Создание нового пользователя');
      // Создаем нового пользователя
      const userData = {
        uid: firebaseUser.uid,
        email: firebaseUser.email || '',
        displayName: firebaseUser.displayName || '',
        photoURL: firebaseUser.photoURL || '',
        favoritesFood: [],
        preferences: [],
        tools: [],
        catType: 'gray',
        userAnalytics: {
          showTutorial: true,
          showClaim: true,
        },
        isPro: false,
        promoGenerations: 0,
        tokens: 126, // Для новых пользователей 126 токенов как указано в вашем коде
        authProvider: 'google',
        registrationDate: new Date().toISOString(),
        lastLoginDate: new Date().toISOString(),
      };

      console.log('📝 Сохранение данных нового пользователя:', userData);
      await setDoc(userDocRef, userData);
      console.log('✅ Новый пользователь сохранен в Firestore');
      
      return {...userData, isNewUser: true};
    } else {
      console.log('👤 Обновление данных существующего пользователя');
      // Обновляем дату последнего входа
      const existingData = userSnapshot.data();
      console.log('📝 Текущие данные пользователя:', existingData);
      
      await setDoc(userDocRef, {
        ...existingData,
        lastLoginDate: new Date().toISOString()
      }, { merge: true });
      
      console.log('✅ Данные пользователя обновлены в Firestore');
      return {...existingData, isNewUser: false};
    }
  } catch (error) {
    console.error('❌ Ошибка при обработке данных пользователя:', error);
    throw error;
  }
}; 